import { useState } from "react";
import fleetApi, { fleetError } from "@/lib/fleetApi";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export const AskOwnerButton = ({ trip }) => {
  const [state, setState] = useState(trip.assign_request ? "sent" : "idle");
  const ask = async () => {
    setState("busy");
    try {
      const { data } = await fleetApi.post(`/trips/${trip.id}/assign-request`, { note: null });
      if (data?.already_requested) toast.info("The owner was already asked about this trip.");
      else toast.success("Owner has been asked to assign this trip.");
      setState("sent");
    } catch (e) {
      if (e.response?.status === 409) { toast.info("The owner was already asked about this trip."); setState("sent"); return; }
      toast.error(fleetError(e, "Couldn't send the request."));
      setState("idle");
    }
  };
  return (
    <button onClick={ask} disabled={state !== "idle"} data-testid={`ask-owner-btn-${trip.id}`}
      className="inline-flex items-center gap-1 rounded border border-slate-700 bg-slate-800/60 px-2 py-0.5 text-[11px] font-medium text-amber-300 transition-colors hover:bg-slate-700 disabled:opacity-60">
      {state === "busy" && <Loader2 className="h-3 w-3 animate-spin" />}
      {state === "sent" ? "Owner asked" : "Ask owner to assign"}
    </button>
  );
};
